import { Link, useLocation } from 'react-router-dom';

const MobileSnb = () => {
  const location = useLocation(); // 현재 경로를 얻기 위해 useLocation 사용

  // 현재 경로에 따라 active 클래스를 추가
  const getActiveClass = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  // 특정 경로일 때만 mobSnbWrap을 렌더링
  const shouldRenderSnb = ['/nhncloud', /* '/naverCloud', */ '/awsCloud'].includes(location.pathname);

  if (!shouldRenderSnb) return null; // 조건에 맞지 않으면 컴포넌트를 렌더링하지 않음

  return (
    <div className="mobSnbWrap">
      <Link to={'/nhncloud'}>
        <div className={`mobSnbBtn nhn ${getActiveClass('/nhncloud')}`}>
          <span>NHN Cloud</span>
        </div>
      </Link>
      {/* <Link to={'/naverCloud'}>
        <div className={`mobSnbBtn naver ${getActiveClass('/naverCloud')}`}>
          <span>Naver Cloud</span>
        </div>
      </Link> */}
      <Link to={'/awsCloud'}>
        <div className={`mobSnbBtn aws ${getActiveClass('/awsCloud')}`}>
          <span>AWS Cloud</span>
        </div>
      </Link>
    </div>
  );
};

export default MobileSnb;
